import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import ExpandingButton from "@/components/Buttons/ExpandingButton";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import teamImg from "@/assets/team/team-join.png";
import Link from "next/link";
import localizePath from "@/functions/localizePath";
import useLocale from "@/hooks/useLocale";

export default function ContentJoin({ content, button, path }) {
  const locale = useLocale();
  const { title, info } = content;

  return (
    <div className={`relative 3xl:max-w-none w-full z-10`}>
      <SourceFlowImage
        src={teamImg ?? ""}
        size="1678x610"
        alt="team"
        className="absolute object-cover w-full h-[100%]"
      />
      <div className="relative  max-w-[80vw] lg:max-w-[55%] w-full flex flex-col gap-5 px-[25px] py-[50px] lg:px-[85px] lg:py-[120px]"
        style={{
          background: "linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0) 70.98%)"
        }}>
        <h2 className="text-3xl sm:text-[40px] xl:text-[50px]/[60px]">
          <CustomSourceFlowText
            title={title}
            path={`dynamic1.${path}.header1`}
            locale={locale}
          />
        </h2>
        <p className="text-base sm:text-xl/[30px]">
          <CustomSourceFlowText
            title={info}
            path={`dynamic1.${path}.text1`}
            locale={locale}
          />
        </p>
        <div className="flex xl:mt-10 lg:mt-0 gap-10">
          <ExpandingButton
            url={button.link}
            color="white"
            bgColor="transparent"
            hoverBGColor="white"
            hoverColor="#1B0D34"
          >
            {button.btn}
          </ExpandingButton>
        </div>
      </div>
    </div>
  );
}
